import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import Main from '../../../main';

/**
 * コンパスポイント入力クラス
 */
export default class ItemControllerCompassPointInput {
  dotList: marietta.core.Point[] = [];

  x: number;

  y: number;

  // lastTime:number;
  currentLine: marietta.webcad.control.parts.StrechLine;

  type: string;

  floor: number;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  public spt: SVGSprite;

  public dotImage: SVGSprite;

  public _arrow: Element;

  private moveMouseEvent: MouseEvent;

  /**
   * コンストラクタ
   */
  constructor() {
    (<HTMLElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
    this.floor = marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor;
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    // ドットイメージの作成
    const _dotImage: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    _dotImage.setAttribute('id', 'dotImage');
    this.tarLayer.viewObj.appendChild(_dotImage);
    this.dotImage = new SVGSprite(_dotImage);

    // ペンの生成
    const targetItem = document.getElementById('lib_icon_pen');
    const viewObj = <SVGElement>targetItem.querySelector('svg > g').cloneNode(true);
    viewObj.setAttribute('id', 'controller_pen');
    this.tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);

    // イベント設定
    const stage = document.querySelector('#layerGroup');
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.addEventListener('touchmove', this.followMouse, { passive: false });
      stage.addEventListener('touchstart', this.makeDot, { passive: false });
    } else {
      stage.addEventListener('mousemove', this.followMouse);
      stage.addEventListener('mousedown', this.makeDot);
    }

    const scope: ItemControllerCompassPointInput = this;
    // comment k.kubonaka
    // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
    // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
    this.spt.onEnterFrame = (): void => {
      if (scope.moveMouseEvent !== null) {
        scope.followMouseHandler();
      }
    };
    ua = null;
    this.forbidOtherEvents();
    // スケールアップデート
    this.updatePickers();
  }

  /**
   * イベント禁止設定
   * ステージホイールイベント禁止
   * keyイベント禁止
   * stage以外のクリックイベント禁止
   */
  private forbidOtherEvents() {
    const self = this;
    marietta.webcad.WebCADGlobal.scrollerManager.scrollEnable = false;
    document.addEventListener('keydown', self.preventKeyEvents);
    document.getElementById('itemMenuWrap').addEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('header').addEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('footer').addEventListener('click', self.preventOutsideStageClickEvents);
    const allButtons = document.getElementsByTagName('button');
    for (let i = 0; i < allButtons.length; i += 1) {
      allButtons[i].addEventListener('click', self.preventKeyEvents);
    }
    const allInput = document.getElementsByTagName('input');
    for (let i = 0; i < allInput.length; i += 1) {
      allInput[i].addEventListener('click', self.preventKeyEvents);
    }
    const allSelect = document.getElementsByTagName('input');
    for (let i = 0; i < allSelect.length; i += 1) {
      allSelect[i].addEventListener('mousedown', self.preventKeyEvents);
    }
    document.getElementById('checkShitaeOpacity').addEventListener('mousedown', self.preventKeyEvents);
    document.getElementById('btnLoadShitae').removeEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeLoadBtnHandler);
    document.getElementById('btnEditShitae').removeEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeEditBtnHandler);
    document.getElementById('btnStageScaleFit').removeEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit);
    document.getElementById('btnStageScalePlus').removeEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementPlus);
    document.getElementById('btnStageScaleMinus').removeEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementMinus);
    document.getElementById('checkSelectMode').removeEventListener('click', Main.btnHeaderSelectModeClickEventHandler);
    document.getElementById('btnUndo').removeEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.undo);
    document.getElementById('btnRedo').removeEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.redo);
    document.getElementById('btnSave2').removeEventListener('click', Main.saveBtnClickEventHandler);
    document.querySelector('#webcadClose > a').removeEventListener('click', Main.webcadCloseBtnClickEventHandler);
    document.querySelector('#btn3D').removeEventListener('click', marietta.webcad.WebCADGlobal.dimensionMenu.btn3DEventHandler);
  }

  /**
   * イベント禁止を解除
   */
  private allowOtherEvents() {
    const self = this;
    marietta.webcad.WebCADGlobal.scrollerManager.scrollEnable = true;
    document.removeEventListener('keydown', self.preventKeyEvents);
    document.getElementById('itemMenuWrap').removeEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('header').removeEventListener('click', self.preventOutsideStageClickEvents);
    document.getElementById('footer').removeEventListener('click', self.preventOutsideStageClickEvents);
    const allButtons = document.getElementsByTagName('button');
    for (let i = 0; i < allButtons.length; i += 1) {
      allButtons[i].removeEventListener('click', self.preventKeyEvents);
    }
    const allInput = document.getElementsByTagName('input');
    for (let i = 0; i < allInput.length; i += 1) {
      allInput[i].removeEventListener('click', self.preventKeyEvents);
    }
    const allSelect = document.getElementsByTagName('input');
    for (let i = 0; i < allSelect.length; i += 1) {
      allSelect[i].removeEventListener('mousedown', self.preventKeyEvents);
    }
    document.getElementById('checkShitaeOpacity').removeEventListener('mousedown', self.preventKeyEvents);
    document.getElementById('btnLoadShitae').addEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeLoadBtnHandler);
    document.getElementById('btnEditShitae').addEventListener('click', marietta.webcad.WebCADGlobal.itemMenu.shitaeEditBtnHandler);
    document.getElementById('btnStageScaleFit').addEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit);
    document.getElementById('btnStageScalePlus').addEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementPlus);
    document.getElementById('btnStageScaleMinus').addEventListener('click', marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementMinus);
    document.getElementById('checkSelectMode').addEventListener('click', Main.btnHeaderSelectModeClickEventHandler);
    document.getElementById('btnUndo').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.undo);
    document.getElementById('btnRedo').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.redo);
    document.getElementById('btnSave2').addEventListener('click', Main.saveBtnClickEventHandler);
    document.querySelector('#webcadClose > a').addEventListener('click', Main.webcadCloseBtnClickEventHandler);
    document.querySelector('#btn3D').addEventListener('click', marietta.webcad.WebCADGlobal.dimensionMenu.btn3DEventHandler);
  }

  /**
   * キーイベントの禁止
   */
  private preventKeyEvents = (e: Event) => {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }

  /**
   * ステージ以外の領域のイベント禁止
   */
  private preventOutsideStageClickEvents = (e: Event) => {
    e.stopImmediatePropagation();
    e.preventDefault();
    if (!(<HTMLElement>e.target).closest('#layerGroup')) {
      return false;
    }
    return false;
  }

  /**
   * マウスの動きでトリガー
   */
  private followMouseHandler() {
    // e.preventDefault();
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    const snapUnit = 1;
    this.spt.x = Math.round(newPoint.x / snapUnit) * snapUnit;
    this.spt.y = Math.round(newPoint.y / snapUnit) * snapUnit;
    this.spt.update();

    // 最後のラインの伸び縮
    if (this.currentLine !== undefined) {
      this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
      const angle: number = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(newPoint, this.currentLine.firstDot) - 90;
      const distance: number = marietta.core.Point.distance(newPoint, this.currentLine.firstDot);
      this._arrow.setAttribute('transform', `matrix(1, 0, 0, 1, ${this.spt.x},${this.spt.y}) rotate(${angle})`);
      if (distance > 20) {
        this._arrow.setAttribute('opacity', '1');
      } else {
        this._arrow.setAttribute('opacity', '0');
      }
    }
  }

  /**
   * マウス追従
   */
  followMouse = (e) => {
    // e.preventDefault();
    this.moveMouseEvent = e;
  }

  /**
   * マウス追従終了
   */
  stopFollowMouse = () => {
    const stage = document.querySelector('#layerGroup');
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      stage.removeEventListener('touchmove', this.followMouse);
      stage.removeEventListener('touchstart', this.makeDot);
    } else {
      stage.removeEventListener('mousemove', this.followMouse);
      stage.removeEventListener('mousedown', this.makeDot);
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;
    }
    ua = null;
    // ペンの削除
    if (document.getElementById('controller_pen')) {
      document.getElementById('controller_pen').remove();
    }
    (<HTMLElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'default';
  }

  /**
   * ドットの作成
   * @param MouseEvent
   */
  makeDot = (e) => {
    e.stopImmediatePropagation();
    // ステージ以外がクリックされたら、囲み入力モードを終了
    const newPoint: marietta.core.Point = new marietta.core.Point(this.tarLayer.spt.mouseX, this.tarLayer.spt.mouseY);
    newPoint.x = Math.round(newPoint.x);
    newPoint.y = Math.round(newPoint.y);
    // const time: Date = new Date();
    // const nowTime: number = time.getTime();
    // 始点に近すぎるところがクリックされたら点を追加しない
    if (this.dotList.length > 2) {
      const startPoint: marietta.core.Point = this.dotList[0] as marietta.core.Point;
      if (marietta.core.Point.distance(newPoint, startPoint) < 10) {
        return;
      }
    }

    // 前のライン類の終点指定
    if (this.currentLine !== undefined) {
      this.currentLine.secondDot = newPoint;
    }
    // 頂点情報の保持
    this.dotList.push(newPoint);

    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;
    // 頂点の作成
    const _dot: Element = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
    _dot.setAttribute('cx', '0');
    _dot.setAttribute('cy', '0');
    _dot.setAttribute('rx', String(5 * sc));
    _dot.setAttribute('ry', String(5 * sc));
    _dot.setAttribute('fill', '#FF0000');
    _dot.setAttribute('id', `dot${this.dotList.length}`);
    const dot: SVGSprite = new SVGSprite(_dot);
    // ドットイメージの作成
    this.dotImage.addChild(dot);
    dot.x = newPoint.x;
    dot.y = newPoint.y;
    dot.update();

    // 矢印
    this._arrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this._arrow.setAttribute('d', 'M0 0 L-6 15 L6 15 Z');
    this._arrow.setAttribute('fill', '#FF0000');
    this._arrow.setAttribute('id', `dot${this.dotList.length}`);
    this._arrow.setAttribute('opacity', '0');
    const arrow: SVGSprite = new SVGSprite(this._arrow);
    this.dotImage.addChild(arrow);

    // ラインの作成
    this.currentLine = new marietta.webcad.control.parts.StrechLine(this.dotImage, this.dotList.length);
    this.currentLine.firstDot = newPoint;
    this.currentLine.secondDot = new marietta.core.Point(this.spt.x, this.spt.y);
    this.currentLine.lineColor = '#FF0000';
    // 最終クリック時間
    // this.lastTime = nowTime;
    // 2点目がクリックされたら終了
    if (this.dotList.length === 2) {
      this.endMakeShape();
    }
  }

  /**
   * 形状作成の終了
   */
  endMakeShape() {
    // マウスの追従終了
    this.stopFollowMouse();
    // 作成用モジュールなど削除する
    this.viewObj.remove();
    this.dotImage.remove();

    // 入力された数値をダイアログに表示
    let rotate: number = marietta.webcad.util.WebCADUtil.getAngleBetweenPoints(this.dotList[0], this.dotList[1]) + 90;
    rotate = Math.round(rotate);
    marietta.webcad.WebCADGlobal.siteCompass.rotate(rotate);
    // 履歴
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // その他のイベント禁止を解除
    this.allowOtherEvents();
  }

  /**
   *
   * HTMLElementの取得
   */
  public get viewObj(): HTMLElement {
    return this.spt.element;
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    const sc: number = 1 / root.scaleX;
    this.spt.scaleX = sc;
    this.spt.scaleY = sc;
    this.spt.update();
  }

  /**
   * 囲み入力の中断
   */
  interrupt() {
    // カーソルをもとに戻す
    (<HTMLElement>document.querySelector('#webcad2dViewInner > svg')).style.cursor = 'none';
    // マウスの追従終了
    this.stopFollowMouse();
    // 作成用モジュールなど削除する
    this.viewObj.remove();
    this.dotImage.remove();
  }
}
